import React, { useEffect, useState } from 'react';
import { Container, Text } from './styles';
import { IconType } from 'react-icons';
import DefaultTooltip from '../DefaultTooltip';
import TotalsService, { AuthorsTotalImp } from '@/services/CalculationsServices/CurrentAccountService/TotalsServices';
import CurrentAuthorImp from '@/interfaces/calculations/CurrentAuthorImp';

interface IProps extends React.DOMAttributes<HTMLButtonElement> {
  title: string;
  Icon?: IconType;
  isAuthor?: boolean;
  authors?: CurrentAuthorImp[];
  updateTo?: string;
}

const Title = ({ updateTo, title, Icon, onClick, authors, isAuthor }: IProps): JSX.Element => {
  const [authorOverview, setAuthorOverview] = useState<AuthorsTotalImp[]>([]);

  useEffect(() => {
    if (!isAuthor) return;
    const totalService = new TotalsService({
      authors,
      updateTo,
    });
    const descriptions = totalService.run({ isFullAuthors: true }) as AuthorsTotalImp[];
    setAuthorOverview(descriptions);
  }, [isAuthor, authors]);

  return (
    <Container onDoubleClick={onClick}>
      {Icon ? <Icon className="icon-title" /> : <></>}
      {isAuthor ? (
        <DefaultTooltip authorsTooltip={authorOverview}>
          <Text>{title.toLocaleUpperCase()}</Text>
        </DefaultTooltip>
      ) : (
        <Text>{title.toLocaleUpperCase()}</Text>
      )}
    </Container>
  );
};

export default Title;
